import React, { useEffect, useState } from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Form,
  FormGroup,
  Label,
  Input,
  Alert,
  Spinner,
} from "reactstrap";
import { useSelector } from "react-redux";
import { getAgent, postCasosCenso } from "../helpers/backend";
import Swal from "sweetalert2";

const CasosCensoModal = ({ isOpen, toggle, onSuccess }) => {
  const user = JSON.parse(localStorage.getItem("user"));
  const groups = String(user.groups);
  const [formData, setFormData] = useState({
    cuenta_contrato_ciudad_limpia: "",
    cuenta_enel: "",
    numero_medidor: "",
    fuente: "",
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [agent, setAgent] = useState({})
  const getAgentData = async () => {
    const response = await getAgent();
    const data = response.data;
    setAgent(data);
  };
  const theme = useSelector((state) => state.theme.theme) || "light";

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
    // Limpiar error cuando el usuario empiece a escribir
    if (error) setError("");
  };

  const validateForm = () => {
    const { cuenta_contrato_ciudad_limpia, cuenta_enel, numero_medidor, fuente } = formData;

    // Verificar que la fuente esté seleccionada
    if (!fuente) {
      setError("Debe seleccionar una fuente");
      return false;
    }

    // Verificar que al menos uno de los campos esté lleno
    if (!cuenta_contrato_ciudad_limpia && !cuenta_enel && !numero_medidor) {
      setError("Debe completar al menos uno de los campos de búsqueda");
      return false;
    }

    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) {
      return;
    }

    setLoading(true);
    setError("");

    try {
      // Filtrar solo los campos que tienen valor
      const dataToSend = {};
      Object.keys(formData).forEach(key => {
        if (formData[key].trim()) {
          dataToSend[key] = formData[key].trim();
        }
      });

      const response = await postCasosCenso(dataToSend);

      // Mostrar mensaje del response
      Swal.fire({
        title: "¡Éxito!",
        text: response.data.message || "  OT de censo creado exitosamente",
        icon: "success",
        confirmButtonText: "Aceptar",
        confirmButtonColor: "#2fa4e7",
      });

      // Limpiar formulario
      setFormData({
        cuenta_contrato_ciudad_limpia: "",
        cuenta_enel: "",
        numero_medidor: "",
        fuente: "",
      });

      // Cerrar modal
      toggle();

      // Callback para actualizar la lista si es necesario
      if (onSuccess) {
        onSuccess();
      }

    } catch (error) {
      console.error("Error al crear caso de censo:", error);

      let errorMessage = "Error al crear el caso de censo";

      if (error.response?.data?.error) {
        errorMessage = error.response.data.error;
      }else if (error.response?.data?.message) {
        errorMessage = error.response.data.message;
      } else if (error.message) {
        errorMessage = error.message;
      }

      Swal.fire({
        title: "Error",
        text: errorMessage,
        icon: "error",
        confirmButtonText: "Aceptar",
        confirmButtonColor: "#dc3545",
      });
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    if (!loading) {
      setFormData({
        cuenta_contrato_ciudad_limpia: "",
        cuenta_enel: "",
        numero_medidor: "",
        fuente: "",
      });
      setError("");
      toggle();
    }
  };
  useEffect(() => {
    getAgentData()
  }, []);

  const handleSelectChange = (e) => {
    const { name, value } = e.target;

    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }));

  };
  return (
    <Modal isOpen={isOpen} toggle={handleClose} centered size="md">
      <ModalHeader
        toggle={handleClose}
        style={{
          backgroundColor: theme === "dark" ? "#242424" : "#fff",
          color: theme === "dark" ? "#c3cbe4" : "#000",
          borderBottom: theme === "dark" ? "1px solid #3b3b3b" : "1px solid #dee2e6",
        }}
      >
        Crear Nueva OT tipo Censo
      </ModalHeader>

      <ModalBody
        style={{
          backgroundColor: theme === "dark" ? "#242424" : "#fff",
          color: theme === "dark" ? "#c3cbe4" : "#000",
        }}
      >
        <Form onSubmit={handleSubmit}>
          {error && (
            <Alert color="danger" className="mb-3">
              {error}
            </Alert>
          )}

          <FormGroup>
            <Label for="cuenta_contrato_ciudad_limpia">
              Cuenta Contrato Ciudad Limpia
            </Label>
            <Input
              type="text"
              id="cuenta_contrato_ciudad_limpia"
              name="cuenta_contrato_ciudad_limpia"
              value={formData.cuenta_contrato_ciudad_limpia}
              onChange={handleInputChange}
              placeholder="Ingrese el número de cuenta contrato"
              disabled={loading}
              style={{
                backgroundColor: theme === "dark" ? "#121212" : "#fff",
                color: theme === "dark" ? "#c3cbe4" : "#000",
                borderColor: theme === "dark" ? "#3b3b3b" : "#ced4da",
              }}
            />
          </FormGroup>

          <FormGroup>
            <Label for="cuenta_enel">
              Cuenta Enel
            </Label>
            <Input
              type="text"
              id="cuenta_enel"
              name="cuenta_enel"
              value={formData.cuenta_enel}
              onChange={handleInputChange}
              placeholder="Ingrese el número de cuenta Enel"
              disabled={loading}
              style={{
                backgroundColor: theme === "dark" ? "#121212" : "#fff",
                color: theme === "dark" ? "#c3cbe4" : "#000",
                borderColor: theme === "dark" ? "#3b3b3b" : "#ced4da",
              }}
            />
          </FormGroup>

          <FormGroup>
            <Label for="numero_medidor">
              Número de Medidor
            </Label>
            <Input
              type="text"
              id="numero_medidor"
              name="numero_medidor"
              value={formData.numero_medidor}
              onChange={handleInputChange}
              placeholder="Ingrese el número de medidor"
              disabled={loading}
              style={{
                backgroundColor: theme === "dark" ? "#121212" : "#fff",
                color: theme === "dark" ? "#c3cbe4" : "#000",
                borderColor: theme === "dark" ? "#3b3b3b" : "#ced4da",
              }}
            />
          </FormGroup>

          <FormGroup>
            <Label for="fuente">
              Fuente *
            </Label>
            <Input
              type="select"
              id="fuente"
              name="fuente"
              value={formData.fuente}
              onChange={handleInputChange}
              disabled={loading}
              required
              style={{
                backgroundColor: theme === "dark" ? "#121212" : "#fff",
                color: theme === "dark" ? "#c3cbe4" : "#000",
                borderColor: theme === "dark" ? "#3b3b3b" : "#ced4da",
              }}
            >
              <option value="">Seleccione una fuente</option>
              <option value="CENSO">CENSO</option>
              <option value="PLAN DE ACTUALIZACION">PLAN DE ACTUALIZACION</option>
              <option value="CARTERA">CARTERA</option>
              <option value="MADRE COMUNITARIA">MADRE COMUNITARIA</option>
            </Input>
          </FormGroup>

          <FormGroup>
            {(groups.includes("Supervisor") || groups.includes("Administrador")  || groups.includes("SuperAdmin")) && (
              <>
                <Label for="cuenta_enel">Visitador</Label>
                <Input
                  type="select"
                  id="agent"
                  name="agent"
                  value={formData.agent || ""}
                  onChange={handleSelectChange}
                  placeholder="Seleccione un visitador"
                  disabled={loading}
                  style={{
                    backgroundColor: theme === "dark" ? "#121212" : "#fff",
                    color: theme === "dark" ? "#c3cbe4" : "#000",
                    borderColor: theme === "dark" ? "#3b3b3b" : "#ced4da",
                  }}
                >
                  <option value="">Seleccione un Visitador</option>
                  {Array.isArray(agent) ? agent
                    .filter(agent => agent.rol === "Agente") // Solo mostrar agentes, no supervisores
                    .map(agent => (
                      <option key={agent.id} value={agent.id}>
                        {agent.full_name} ({agent.username})
                      </option>
                    )):[]}
                </Input>
              </>
            )}
          </FormGroup>

          <div className="text-muted small">
            <strong>Nota:</strong> Debe completar al menos uno de los campos para crear el caso de censo.
          </div>
        </Form>
      </ModalBody>

      <ModalFooter
        style={{
          backgroundColor: theme === "dark" ? "#242424" : "#fff",
          borderTop: theme === "dark" ? "1px solid #3b3b3b" : "1px solid #dee2e6",
        }}
      >
        <Button
          color="secondary"
          onClick={handleClose}
          disabled={loading}
        >
          Cancelar
        </Button>
        <Button
          color="primary"
          onClick={handleSubmit}
          disabled={loading}
        >
          {loading ? (
            <>
              <Spinner size="sm" className="me-2" />
              Creando...
            </>
          ) : (
            "Crear Caso"
          )}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default CasosCensoModal;